import React, {useState} from "react";
import Select from 'react-select';

import { getLanguageSeriesLevels } from "../common/functions";

import {Card} from 'react-bootstrap';

const SeriesSelectPartial = ({language, data = null, setSelectedSeriesHandler, setSelectedLevelsHandler, setSelectedVolumesHandler, showSubSelect = true}) => {

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedVolumes, setSelectedVolumes] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    setSelectedLevels([]);
    setSelectedLevelsHandler([]);
    setSelectedSeriesHandler(selected);
  };

  const handleChangeLevel = (selected) => {
    setSelectedLevels(selected);
    setSelectedLevelsHandler(selected);
  };

  const handleChangeVolume = (selected) => {
    setSelectedVolumes(selected);
    setSelectedVolumesHandler(selected)
  };

  let series = [];
  let levels = [];
  let volumes = [];
  if(data != null){
    const response = data;
    if(response.length > 0 && Object.keys(response).length > 0){
      for(var i = 0; i <= response.length-1; i++){
        if(response[i].series !== undefined && Object.keys(response[i].series).length > 0){
          for(var j = 0; j <= response[i].series.length-1; j++){
            if(response[i].series[j].slug !== undefined){
              series.push({label: response[i].series[j].name, value: response[i].series[j].slug});
              if(showSubSelect === true){
                levels.push({slug: response[i].series[j].slug, age: response[i].series[j].age});
              }
              
            }
           
          }
        }

        if(response[i].volumes !== undefined && Object.keys(response[i].volumes).length > 0){
          for(var j = 0; j <= response[i].volumes.length-1; j++){
            if(response[i].volumes[j].slug !== undefined && showSubSelect === true){
              volumes.push({label: response[i].volumes[j].name, value: response[i].volumes[j].slug});
            }
            
          }
        }
      }

      series = series.filter((value, index, self) =>
        index === self.findIndex((v) =>
          v.label === value.label && v.value === value.value
        )
      );

      if(showSubSelect === true) {
        volumes = volumes.filter((value, index, self) =>
        index === self.findIndex((v) =>
          v.label === value.label && v.value === value.value
        )
      );
      }
      
    }
  }

  const selectedValues = selectedOptions.map(option => option.value);
  let filteredArray = [];
  if(selectedValues.length > 0){
    if(language == "wychowanie-przedszkolne"){
      filteredArray = levels.filter(item => selectedValues.includes(item.slug)).map((item) => {return {label : item.age, value : item.age}});
    }
    else{
   
      if(showSubSelect){
        let volumesToRetrieve = data
        .flatMap(item => item.series.some(series => selectedValues.includes(series.slug)) ? item.volumes : [])
        .filter((volume, index, self) => self.findIndex(v => v.slug === volume.slug) === index);
        
      const slugToNumber = (slug) => {
        Number(slug.split('-')[1]);
      };
      volumesToRetrieve.sort((a, b) => slugToNumber(a.slug) - slugToNumber(b.slug));
      if(Object.keys(volumesToRetrieve).length > 0){
        filteredArray = volumesToRetrieve.map((item) => {return {label : item.name, value : item.slug}});
      }
      }
     
    }

    
    if(filteredArray.length > 0){
      filteredArray.sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        } 
        else if (a.value > b.value) {
          return 1;
        } 
        else {
          return 0;
        }
      });

      filteredArray = filteredArray.filter((value, index, self) =>
        index === self.findIndex((v) =>
          v.value === value.value
        )
      );

      for (let i = 0; i < filteredArray.length; i++) {
        filteredArray[i].value = filteredArray[i].value
      }
    }
  }
  else{
    filteredArray = [];
  }

  let levelsSelect = null;
  if(filteredArray.length > 0){
    if(language == "wychowanie-przedszkolne"){
      var placeholderValue = "Wybierz grupy wiekowe";
      levelsSelect = <Select placeholder={placeholderValue} options={filteredArray} isMulti value={selectedLevels} onChange={handleChangeLevel} />
    }
    else{
      var placeholderValue = "Wybierz tom";
      levelsSelect = <Select placeholder={placeholderValue} options={filteredArray} isMulti value={selectedVolumes} onChange={handleChangeVolume} />
    }
  }

  series.sort((a, b) => {
    if(a.label !== null && b.label !== null){
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
    
      if (labelA < labelB) {
        return -1;
      }
      if (labelA > labelB) {
        return 1;
      }
    }
    return 0;
  });

  return(
    <React.Fragment>
      <Card className="bg-violet">
        <Card.Body>
          <Select placeholder="Wybierz serie wydawnicze" options={series} isMulti value={selectedOptions} onChange={handleChange} />  
          {levelsSelect}
        </Card.Body>
      </Card>
    </React.Fragment>
  )

}
export default SeriesSelectPartial;